<template>

    <div class="dply_detail-page" v-bind:class="[{ _brand: showBrand }, { _showroom: showShowRoom }]"
                                    v-bind:style="{ paddingTop: pageTypeTop, paddingBottom: pageTypeBottom}">
        <div class="inner">

            <div v-if="pageTypeStep10 != 2"  class="intro-notice-wrap">
                <div class="intro-notice-inner">
                    <h2><span>{{getName}}</span>詳細ページを作成後、{{getTextStep10}}へとお進み頂けます</h2>
                    <ol class="list_number">
                        <li>
                            <div class="number"></div>
                            <p><span>各種項目を編集</span></p>
                        </li>
                        <li>
                            <div class="number"></div>
                            <p><span>「プレビューを確認する」ボタンをクリック</span></p>
                        </li>
                        <li>
                            <div class="number"></div>
                            <p><span>編集内容に間違えがなければ「この内容で{{getTextStep10}}する」ボタンをクリック</span></p>
                        </li>
                    </ol>
                </div>
            </div>

            <!----------------------------------------------
                PageNameRow
            ------------------------------------------------->
            <Step1001Name v-bind:class="{_display_none: show_preview}"/>

            <Step1001NamePreview v-on:toast="$emit('toast', $event)" />

            <!----------------------------------------------
                MainImage
            ------------------------------------------------->
            <Step1002MainImage v-on:openCropper="showCropperModal"
                                @deleteImage="deleteImage"
                                v-bind:mainImages="mainImage"
                                v-bind:show_preview="show_preview"
                                v-bind:class="{_display_none: show_preview}"/>

            <Step1002MainImagePreview v-bind:mainImages="mainImage" />

            <!----------------------------------------------
                SubImage
            ------------------------------------------------->
            <Step1003SubImage v-if="(showBrand && activeBasicBrand) ||
                                        showShowRoom || 
                                        showRoomAndBasic"
                                v-on:openCropper="showCropperModal"
                                @deleteImage="deleteImage"
                                v-bind:subImages="subImage"
                                v-bind:show_preview="show_preview"
                                v-bind:class="{_display_none: show_preview}"/>

            <Step1003SubImagePreview v-if="(showBrand && personalAndBasic) ||
                                            (showBrand && unitAndBasic) ||
                                            (showBrand && adminAndBasic) ||
                                            (pageTypeStep10 == 1 && activeBasicBrand) ||
                                            (pageTypeStep10 == 1 && showShowRoom) ||
                                            (showShowRoom && personalAndShowRoom) ||
                                            (showShowRoom && unitAndShowRoom) ||
                                            basicAndShowRoom ||
                                            showRoomAndBasic"
                                    v-bind:subImages="subImage" />

            <!----------------------------------------------
                Concept
            ------------------------------------------------->
            <Step1006Concept v-bind:class="{_display_none: show_preview}"/>

            <Step1006ConceptPreview />

            <!----------------------------------------------
                PR
            ------------------------------------------------->
            <Step1004Pr v-if="showBrand" v-bind:class="{_display_none: show_preview}"/>

            <Step1004PrPreview v-if="showBrand"/>

            <!----------------------------------------------
                MainInfo
            ------------------------------------------------->
            <Step1005MainInfo v-if="showBrand && activeBasicBrand ||
                                    showRoomAndBasic"
                                v-bind:class="{_display_none: show_preview}"/>

            <Step1005MainInfoPreview v-if="!showShop && ((showBrand && personalAndBasic) ||
                                            (showBrand && unitAndBasic) ||
                                            (showBrand && adminAndBasic) ||
                                            (pageTypeStep10 == 1 && activeBasicBrand) ||
                                            basicAndShowRoom ||
                                            showRoomAndBasic)" />

            <!----------------------------------------------
                Area
            ------------------------------------------------->
            <Step1009Area v-if="showBrand && activeBasicBrand" v-bind:class="{_display_none: show_preview}"/>
            <Step1009AreaPreview v-if="(showBrand && unitAndBasic) ||
                                        (showBrand && adminAndBasic) ||
                                        (pageTypeStep10 == 1 && activeBasicBrand) ||
                                        showRoomAndBasic" />

            <!----------------------------------------------
                Sales Brands Info
            ------------------------------------------------->
            <Step1014SalesBrandsInfo @openAlertModal="openAlertModal"
                                        v-if="(showBrand && personalAndBasic) ||
                                            (showBrand && unitAndBasic) ||
                                            (showBrand && adminAndBasic) ||
                                            (pageTypeStep10 == 1 && activeBasicBrand) ||
                                            basicAndShowRoom ||
                                            showRoomAndBasic"/>

            <!-- <Step1014SalesBrandsInfoPreview v-if="showShowRoom" @openAlertModal="openAlertModal"/> -->

            <!----------------------------------------------
                OtherBrand
            ------------------------------------------------->
            <Step1017OtherBrand v-if="showShowRoom" v-bind:class="{_display_none: show_preview}"/>

            <Step1017OtherBrandPreview v-if="showShowRoom"/>

            <!----------------------------------------------
                PriceImage
            ------------------------------------------------->
            <Step1007PriceImage v-if="showBrand && activeBasicBrand"
                                v-on:openCropper="showCropperModal"
                                @deleteImage="deleteImage"
                                v-on:updateDatas="setPriceImages"
                                v-bind:priceImages="priceImage"
                                v-bind:show_preview="show_preview"
                                v-bind:class="{_display_none: show_preview}"/>

            <Step1007PriceImagePreview v-if="(showBrand && personalAndBasic) ||
                                                (showBrand && unitAndBasic) ||
                                                (showBrand && adminAndBasic) ||
                                                (pageTypeStep10 == 1 && activeBasicBrand) ||
                                                basicAndShowRoom ||
                                                showRoomAndBasic"
                                        v-bind:priceImages="priceImage"/>

            <!----------------------------------------------
                Exhibition & Movie
            ------------------------------------------------->

            
            <Step1008ExhibitionMovie :showMovie="(showBrand && activeBasicBrand) ||
                                                    showShowRoom"
                                    v-bind:class="{_display_none: show_preview}"/>

            <Step1008ExhibitionMoviePreview :showMovie="(showBrand && personalAndBasic) ||
                                                    (showBrand && unitAndBasic) ||
                                                    (showBrand && adminAndBasic) ||
                                                    (pageTypeStep10 == 1 && activeBasicBrand) ||
                                                    (pageTypeStep10 == 1 && showShowRoom) ||
                                                    (showShowRoom && personalAndShowRoom) ||
                                                    (showShowRoom && unitAndShowRoom) ||
                                                    basicAndShowRoom ||
                                                    showRoomAndBasic" />

            <!----------------------------------------------
                Detail
            ------------------------------------------------->
            <Step1010Detail v-bind:class="{_display_none: show_preview}"/>

            <Step1010DetailPreview />

            <!----------------------------------------------
                Hitotonari
            ------------------------------------------------->
            <section class="hitotonari-section _edit-section" v-if="(showBrand && activeBasicBrand) || showShowRoom"  v-bind:class="{_display_none: show_preview}">
                <div class="section-inner">
                    <h2 class="heading-section"><span>hitotonari.</span></h2>
                    <!-- HiddenSelect -->
                    <div class="hidden-select">
                        <div class="title"><span>hitotonari.を表示しますか？</span></div>
                        <div class="radio">
                            <div class="item form_radio">
                                <input type="radio" name="hitotonari-display" class="" id="hitotonari-display-false" v-bind:value="false" v-bind:checked="hitotonari.display == false" v-on:input="displayHitotoanri($event)">
                                <label for="hitotonari-display-false">
                                    <span>表示しない</span>
                                </label>
                            </div>
                            <div class="item form_radio">
                                <input type="radio" name="hitotonari-display" class="" id="hitotonari-display-true" v-bind:value="true" v-bind:checked="hitotonari.display == true" v-on:input="displayHitotoanri($event)">
                                <label for="hitotonari-display-true">
                                    <span>表示する</span>
                                </label>
                            </div>
                        </div>
                    </div><!-- /.HiddenSelect -->
                    <HitotonariEdit
                    v-on:openCropper="showCropperModal"
                    @deleteImage="deleteImage"
                    v-on:deleteQAndA="deleteQAndAList"
                    v-on:addQAndA="addQAndAList"
                    v-on:inputHitotonariItems="inputHitotonariItemsList"
                    v-on:inputHitotonariQAndA="inputHitotonariQAndAList"
                    v-bind:hitotonariData="hitotonari"
                    v-bind:display="hitotonari.display" />
                </div>
            </section>

            <section class="hitotonari-section _preview-section" v-if="(showBrand && personalAndBasic) ||
                                                                        (showBrand && unitAndBasic) ||
                                                                        (showBrand && adminAndBasic) ||
                                                                        (pageTypeStep10 == 1 && activeBasicBrand) ||
                                                                        (pageTypeStep10 == 1 && showShowRoom) ||
                                                                        (showShowRoom && personalAndShowRoom) ||
                                                                        (showShowRoom && unitAndShowRoom) ||
                                                                        basicAndShowRoom ||
                                                                        showRoomAndBasic">

                <div class="section-inner">
                    <HitotonariDetail v-bind:hitotonariData="hitotonari" v-bind:display="hitotonari.display"/>
                </div>
            </section>

            <!----------------------------------------------
                Hashtags
            ------------------------------------------------->
            <Step1011HashTags v-if="(showBrand && activeBasicBrand) ||
                                    showShowRoom"
                                v-bind:class="{_display_none: show_preview}"/>

            <Step1011HashTagsPreview v-if="(showBrand && unitAndBasic) ||
                                            (showBrand && adminAndBasic) ||
                                            (pageTypeStep10 == 1 && activeBasicBrand) ||
                                            (pageTypeStep10 == 1 && showShowRoom) ||
                                            (showShowRoom && personalAndShowRoom) ||
                                            (showShowRoom && unitAndShowRoom) ||
                                            basicAndShowRoom ||
                                            showRoomAndBasic" />

            <!----------------------------------------------
                SNS Accounts
            ------------------------------------------------->
            <Step1016SnsAccounts v-bind:class="{_display_none: show_preview}"/>
            <!----------------------------------------------
                SalesInfo
            ------------------------------------------------->
            <Step1015SalesInfoPreview v-if="(showBrand && personalAndBasic) ||
                                            (showBrand && unitAndBasic) ||
                                            (showBrand && adminAndBasic) ||
                                            (pageTypeStep10 == 1 && activeBasicBrand) ||
                                            (pageTypeStep10 == 1 && showShowRoom) ||
                                            (showShowRoom && personalAndShowRoom) ||
                                            (showShowRoom && unitAndShowRoom) ||
                                            basicAndShowRoom ||
                                            showRoomAndBasic"/>

            <!----------------------------------------------
                Company
            ------------------------------------------------->
            <Step1012CompanyPreview 
                v-if="(showBrand && personalAndBasic) ||
                        (showBrand && unitAndBasic) ||
                        (showBrand && adminAndBasic) ||
                        (pageTypeStep10 == 1 && activeBasicBrand) ||
                        (pageTypeStep10 == 1 && showShowRoom) ||
                        (showShowRoom && personalAndShowRoom) ||
                        (showShowRoom && unitAndShowRoom) ||
                        basicAndShowRoom ||
                        showRoomAndBasic"/>

            <!----------------------------------------------
                MySelectRoomAdd
            ------------------------------------------------->
            <Step1018MySelectRoomAdd v-on:toast="$emit('toast', $event)"/>

            <!----------------------------------------------
                Share
            ------------------------------------------------->
            <Step1013Sns v-if="showBrand || showShowRoom" @openAlertModal="openAlertModal" />

            <!----------------------------------------------
                Modal
            ------------------------------------------------->
            <ModalCropper v-if="showContent"
                            v-on:setCropper="setCropperImage"
                            v-on:closeCropper="closeCropperModal"
                            v-bind:imageData="cropperImage"/>


        </div><!--/.dply_detail-page-inner-->
    </div><!--/.dply_detail-page-->
    <AlertModal 
        v-if="showAlertModal" 
        @close="closeAlertModal" 
        :title="alert_modal_title" 
        :message="alert_modal_message"
        :mode="alert_modal_mode" 
    />
    <ConfirmModalWithPromise ref="confirmModal" />

</template>

<script>
    //Parts
    import Step1001Name from '@/components/EndUser/MembershipRegistrationShopStep/Step10Parts/01Name'
    import Step1002MainImage from '@/components/EndUser/MembershipRegistrationShopStep/Step10Parts/02MainImage'
    import Step1003SubImage from '@/components/EndUser/MembershipRegistrationShopStep/Step10Parts/03SubImage'
    import Step1004Pr from '@/components/EndUser/MembershipRegistrationShopStep/Step10Parts/04Pr'
    import Step1005MainInfo from '@/components/EndUser/MembershipRegistrationShopStep/Step10Parts/05MainInfo'
    import Step1006Concept from '@/components/EndUser/MembershipRegistrationShopStep/Step10Parts/06Concept'
    import Step1007PriceImage from '@/components/EndUser/MembershipRegistrationShopStep/Step10Parts/07PriceImage'
    import Step1008ExhibitionMovie from '@/components/EndUser/MembershipRegistrationShopStep/Step10Parts/08ExhibitionMovie'
    import Step1009Area from '@/components/EndUser/MembershipRegistrationShopStep/Step10Parts/09Area'
    import Step1010Detail from '@/components/EndUser/MembershipRegistrationShopStep/Step10Parts/10Detail'
    import Step1011HashTags from '@/components/EndUser/MembershipRegistrationShopStep/Step10Parts/11HashTags'
    import HitotonariDetail from '@/components/EndUser/HitotonariDetail'
    import HitotonariEdit from '@/components/EndUser/HitotonariEdit'
    import Step1013Sns from '@/components/EndUser/MembershipRegistrationShopStep/Step10Parts/13Sns'
    import Step1014SalesBrandsInfo from '@/components/EndUser/MembershipRegistrationShopStep/Step10Parts/14SalesBrandsInfo'
    import Step1016SnsAccounts from '@/components/EndUser/MembershipRegistrationShopStep/Step10Parts/16SnsAccounts'
    import Step1017OtherBrand from '@/components/EndUser/MembershipRegistrationShopStep/Step10Parts/17OtherBrand'
    import Step1018MySelectRoomAdd from '@/components/EndUser/MembershipRegistrationShopStep/Step10Parts/18MySelectRoomAdd'

    //PartsPreview
    import Step1001NamePreview from '@/components/EndUser/MembershipRegistrationShopStep/Step10Parts/01NamePreview'
    import Step1002MainImagePreview from '@/components/EndUser/MembershipRegistrationShopStep/Step10Parts/02MainImagePreview'
    import Step1003SubImagePreview from '@/components/EndUser/MembershipRegistrationShopStep/Step10Parts/03SubImagePreview'
    import Step1004PrPreview from '@/components/EndUser/MembershipRegistrationShopStep/Step10Parts/04PrPreview'
    import Step1005MainInfoPreview from '@/components/EndUser/MembershipRegistrationShopStep/Step10Parts/05MainInfoPreview'
    import Step1006ConceptPreview from '@/components/EndUser/MembershipRegistrationShopStep/Step10Parts/06ConceptPreview'
    import Step1007PriceImagePreview from '@/components/EndUser/MembershipRegistrationShopStep/Step10Parts/07PriceImagePreview'
    import Step1008ExhibitionMoviePreview from '@/components/EndUser/MembershipRegistrationShopStep/Step10Parts/08ExhibitionMoviePreview'
    import Step1009AreaPreview from '@/components/EndUser/MembershipRegistrationShopStep/Step10Parts/09AreaPreview'
    import Step1010DetailPreview from '@/components/EndUser/MembershipRegistrationShopStep/Step10Parts/10DetailPreview'
    import Step1011HashTagsPreview from '@/components/EndUser/MembershipRegistrationShopStep/Step10Parts/11HashTagsPreview'
    import Step1012CompanyPreview from '@/components/EndUser/MembershipRegistrationShopStep/Step10Parts/12CompanyPreview'
    import Step1014SalesBrandsInfoPreview from '@/components/EndUser/MembershipRegistrationShopStep/Step10Parts/14SalesBrandsInfoPreview'
    import Step1015SalesInfoPreview from '@/components/EndUser/MembershipRegistrationShopStep/Step10Parts/15SalesInfoPreview'
    import Step1017OtherBrandPreview from '@/components/EndUser/MembershipRegistrationShopStep/Step10Parts/17OtherBrandPreview'

    import ModalCropper from '@/components/EndUser/ModalCropper'
    import AlertModal from '@/components/EndUser/ComponentList/AlertModal'
    import ConfirmModalWithPromise from '@/components/EndUser/ComponentList/ConfirmModalWithPromise'

    export default {
        components: {
            //Parts
            Step1002MainImage,
            Step1001Name,
            Step1008ExhibitionMovie,
            Step1005MainInfo,
            Step1006Concept,
            Step1008ExhibitionMoviePreview,
            Step1003SubImage,
            Step1004Pr,
            Step1007PriceImage,
            Step1009Area,
            Step1010Detail,
            Step1011HashTags,
            HitotonariDetail,
            HitotonariEdit,
            Step1013Sns,
            Step1014SalesBrandsInfo,
            Step1016SnsAccounts,
            Step1017OtherBrand,
            Step1018MySelectRoomAdd,
            //PartsPreview
            Step1002MainImagePreview,
            Step1001NamePreview,
            Step1005MainInfoPreview,
            Step1006ConceptPreview,
            Step1004PrPreview,
            Step1003SubImagePreview,
            Step1007PriceImagePreview,
            Step1009AreaPreview,
            Step1010DetailPreview,
            Step1011HashTagsPreview,
            Step1012CompanyPreview,
            Step1014SalesBrandsInfoPreview,
            Step1015SalesInfoPreview,
            Step1017OtherBrandPreview,
            ModalCropper,
            "AlertModal": AlertModal,
            "ConfirmModalWithPromise": ConfirmModalWithPromise,
        },
        data() {
            return {
                showContent: false,
                cropperImage: {
                    src: "",
                    type: "",
                    domWidth: "",
                    domHeight: "",
                },
                mainImage: {
                    1: "/img/no-image.svg",
                    2: "/img/no-image.svg",
                },
                subImage: {
                    1: "/img/no-image.svg",
                    2: "/img/no-image.svg",
                    3: "/img/no-image.svg",
                    4: "/img/no-image.svg",
                },
                priceImage: {
                    1: {image: "/img/no-image.svg", name: '', price: '', description: '', stock: false},
                    2: {image: "/img/no-image.svg", name: '', price: '', description: '', stock: false},
                    3: {image: "/img/no-image.svg", name: '', price: '', description: '', stock: false},
                    4: {image: "/img/no-image.svg", name: '', price: '', description: '', stock: false},
                    5: {image: "/img/no-image.svg", name: '', price: '', description: '', stock: false},
                    6: {image: "/img/no-image.svg", name: '', price: '', description: '', stock: false},
                    7: {image: "/img/no-image.svg", name: '', price: '', description: '', stock: false},
                    8: {image: "/img/no-image.svg", name: '', price: '', description: '', stock: false},
                    9: {image: "/img/no-image.svg", name: '', price: '', description: '', stock: false},
                    10: {image: "/img/no-image.svg", name: '', price: '', description: '', stock: false},
                },
                hitotonari: {
                    image: {
                        1: "/img/no-image.svg",
                        2: "/img/no-image.svg",
                        3: "/img/no-image.svg",
                    },
                    post: '',
                    name: '',
                    title: '',
                    description: '',
                    history: '',
                    facebook: '',
                    twitter: '',
                    instagram: '',
                    questionAndAnswers: {
                        1: {question_check: 0, question_select_id: 0, question: '', answer: ''},
                        2: {question_check: 0, question_select_id: 0, question: '', answer: ''},
                        3: {question_check: 0, question_select_id: 0, question: '', answer: ''},
                    },
                    display: false,
                },
                brandPlanBasicAndActive: false,
                planStatus: '',
                pageTypeTop: '',
                pageTypeBottom: '',
                showAlertModal: false,
                alert_modal_title: "",
                alert_modal_message: "",
                alert_modal_mode: "",
            };
        },
        props: {
            show_preview: Object,
        },
        mounted: function() {
            this.setDefaultData();
        },
        methods: {
            setDefaultData() {
                this.$store.state.register.form.main_images = this.mainImage;
                this.$store.state.register.form.sub_images = this.subImage;
                this.$store.state.register.form.price_images = this.priceImage;
                this.$store.state.register.form.hitotonari = this.hitotonari;

                if (this.$store.state.detail.set.brand.brand_images) {
                    for (let i = 0; i < Object.keys(this.$store.state.detail.set.brand.brand_images).length; i++) {
                        var periodPlace = this.$store.state.detail.set.brand.brand_images[i].path.indexOf('.');
                        var key = this.$store.state.detail.set.brand.brand_images[i].path.charAt(periodPlace - 1);
                        this.mainImage[key] = this.$store.state.const.AWS_S3_URL_HOST + this.$store.state.detail.set.brand.brand_images[i].path;
                    }
                    this.$store.state.register.form.main_images = this.mainImage;
                }
                if (this.$store.state.detail.set.brand.shop_images) {
                    for (let i = 0; i < Object.keys(this.$store.state.detail.set.brand.shop_images).length; i++) {
                        var periodPlace = this.$store.state.detail.set.brand.shop_images[i].path.indexOf('.');
                        var key = this.$store.state.detail.set.brand.shop_images[i].path.charAt(periodPlace - 1);
                        this.mainImage[key] = this.$store.state.const.AWS_S3_URL_HOST + this.$store.state.detail.set.brand.shop_images[i].path;
                    }
                    this.$store.state.register.form.main_images = this.mainImage;
                }
                if (this.$store.state.detail.set.brand.sub_images) {
                    for (let i = 0; i < Object.keys(this.$store.state.detail.set.brand.sub_images).length; i++) {
                        var periodPlace = this.$store.state.detail.set.brand.sub_images[i].path.indexOf('.');
                        var key = this.$store.state.detail.set.brand.sub_images[i].path.charAt(periodPlace - 1);
                        this.subImage[key] = this.$store.state.const.AWS_S3_URL_HOST + this.$store.state.detail.set.brand.sub_images[i].path;
                    }
                    this.$store.state.register.form.sub_images = this.subImage;
                }
                if (this.$store.state.detail.set.brand.price_images) {
                    for (let i = 0; i < Object.keys(this.$store.state.detail.set.brand.price_images).length; i++) {
                        var key = this.$store.state.detail.set.brand.price_images[i].item_number;
                        if (this.$store.state.detail.set.brand.price_images[i].path) {
                            this.priceImage[key].image = this.$store.state.const.AWS_S3_URL_HOST + this.$store.state.detail.set.brand.price_images[i].path;
                        }
                        this.priceImage[key].name = this.$store.state.detail.set.brand.price_images[i].name;
                        this.priceImage[key].price = this.$store.state.detail.set.brand.price_images[i].price;
                        this.priceImage[key].description = this.$store.state.detail.set.brand.price_images[i].description;
                        this.priceImage[key].stock = this.$store.state.detail.set.brand.price_images[i].stock;
                    }
                    this.$store.state.register.form.price_images = this.priceImage;

                }
                if (this.$store.state.detail.set.brand.hitotonaris && this.$store.state.detail.set.brand.hitotonaris.length > 0) {
                    if (this.$store.state.detail.set.brand.hitotonaris[0].images) {
                        for (let i = 0; i < this.$store.state.detail.set.brand.hitotonaris[0].images.length; i++) {
                            var periodPlace = this.$store.state.detail.set.brand.hitotonaris[0].images[i].path.indexOf('.');
                            var key = this.$store.state.detail.set.brand.hitotonaris[0].images[i].path.charAt(periodPlace - 1);
                            this.hitotonari.image[key] = this.$store.state.const.AWS_S3_URL_HOST + this.$store.state.detail.set.brand.hitotonaris[0].images[i].path;
                        }
                    }
                    if (this.$store.state.detail.set.brand.hitotonaris[0].recommendation) {
                        for (let i = 0; i < this.$store.state.detail.set.brand.hitotonaris[0].recommendation.length; i++) {
                            this.hitotonari.questionAndAnswers[i+1].question_check = this.$store.state.detail.set.brand.hitotonaris[0].recommendation[i].question_check;
                            this.hitotonari.questionAndAnswers[i+1].question_select_id = this.$store.state.detail.set.brand.hitotonaris[0].recommendation[i].question_select_id;
                            this.hitotonari.questionAndAnswers[i+1].question = this.$store.state.detail.set.brand.hitotonaris[0].recommendation[i].question;
                            this.hitotonari.questionAndAnswers[i+1].answer = this.$store.state.detail.set.brand.hitotonaris[0].recommendation[i].answer;
                        }
                    }
                    this.hitotonari.post = this.$store.state.detail.set.brand.hitotonaris[0].post;
                    this.hitotonari.name = this.$store.state.detail.set.brand.hitotonaris[0].name;
                    this.hitotonari.title = this.$store.state.detail.set.brand.hitotonaris[0].title;
                    this.hitotonari.description = this.$store.state.detail.set.brand.hitotonaris[0].description;
                    this.hitotonari.history = this.$store.state.detail.set.brand.hitotonaris[0].history;
                    this.hitotonari.facebook = this.$store.state.detail.set.brand.hitotonaris[0].facebook;
                    this.hitotonari.twitter = this.$store.state.detail.set.brand.hitotonaris[0].twitter;
                    this.hitotonari.instagram = this.$store.state.detail.set.brand.hitotonaris[0].instagram;
                    this.hitotonari.display = this.$store.state.detail.set.brand.hitotonaris[0].display;

                    this.$store.state.register.form.hitotonari = this.hitotonari;
                }
                // Step1012Companyを使わなくなったためここでCompanyPreviewに必要な情報をregister.formに移す
                if (this.$store.state.detail.set.brand.company) {
                    const { name, phonetic, post_code, address, google_map_url, tel, facebook, twitter, instagram, line, description } = this.$store.state.detail.set.brand.company;
                    this.$store.state.register.form.company_name = name;
                    this.$store.state.register.form.company_phonetic = phonetic;
                    this.$store.state.register.form.company_post_code = post_code;
                    this.$store.state.register.form.company_address = address;
                    this.$store.state.register.form.google_map_url = google_map_url;
                    this.$store.state.register.form.company_tel = tel;
                    this.$store.state.register.form.company_facebook_url = facebook;
                    this.$store.state.register.form.company_twitter_url = twitter;
                    this.$store.state.register.form.company_instagram_url = instagram;
                    this.$store.state.register.form.company_line_url = line;
                    this.$store.state.register.form.company_concept = description;
                }
            },
            showCropperModal(imgDatas) {
                this.$store.state.register.crop.image_target = imgDatas.target;
                this.cropperImage.src = imgDatas.src;
                this.cropperImage.type = imgDatas.type;
                this.cropperImage.domWidth = imgDatas.domWidth;
                this.cropperImage.domHeight = imgDatas.domHeight;
                this.showContent = true;
                this.$emit("openCropperModal");
            },
            closeCropperModal() {
                this.showContent = false;
                this.$emit("closeCropperModal");
            },
            setCropperImage() {
                var target = this.$store.state.register.crop.image_target;
                var dataParam = target.id.split('-img');
                var key = dataParam[1];

                switch (dataParam[0]) {
                    case 'main':
                        this.mainImage[key] = this.$store.state.register.crop.temp_image;
                        this.$store.state.register.form.main_images[key] = this.mainImage[key];
                        break;
                    case 'sub':
                        this.subImage[key] = this.$store.state.register.crop.temp_image;
                        this.$store.state.register.form.sub_images[key] = this.subImage[key];
                        break;
                    case 'price':
                        this.priceImage[key].image = this.$store.state.register.crop.temp_image;
                        this.$store.state.register.form.price_images[key].image = this.priceImage[key].image;
                        break;
                    case 'hitotonari':
                        this.hitotonari.image[key] = this.$store.state.register.crop.temp_image;
                        this.$store.state.register.form.hitotonari.image[key] = this.hitotonari.image[key];
                        break;
                }
            },
            deleteImage(key, type){
                let toDelete;
                switch (type) {
                    case 'main':
                        toDelete = this.mainImage[key];
                        this.mainImage[key] = "/img/no-image.svg";
                        //this.$store.state.register.form.main_images[key] = this.mainImage[key];
                        break;
                    case 'sub':
                        toDelete = this.subImage[key];
                        this.subImage[key] = "/img/no-image.svg";
                        //this.$store.state.register.form.sub_images[key] = this.subImage[key];
                        break;
                    case 'price':
                        toDelete = this.priceImage[key].image;
                        this.priceImage[key].image = "/img/no-image.svg";
                        //this.$store.state.register.form.price_images[key].image = this.priceImage[key].image;
                        break;
                    case 'hitotonari':
                        toDelete = this.hitotonari.image[key];
                        this.hitotonari.image[key] = "/img/no-image.svg";
                        //this.$store.state.register.form.hitotonari.image[key] = this.hitotonari.image[key];
                        break;
                }
                if(toDelete.includes('.amazonaws.com/')){
                    this.$store.state.register.form.delete_images.push(toDelete);
                }
            },
            setPriceImages(data) {
                var dataParam = data.id.split('_');
                var key = dataParam[1];

                switch (dataParam[0]) {
                    case 'name':
                        this.priceImage[key].name = data.value;
                        break;
                    case 'price':
                        this.priceImage[key].price = data.value;
                        break;
                    case 'description':
                        this.priceImage[key].description = data.value;
                        break;
                    case 'stock-false':
                    case 'stock-true':
                        this.priceImage[key].stock = data.value;
                        break;
                }
            },
            inputHitotonariItemsList(item) {
                this.hitotonari.[item.type] = item.value;
                this.$store.state.register.form.hitotonari.[item.type] = this.hitotonari.[item.type];
            },
            inputHitotonariQAndAList(item) {
                this.hitotonari.questionAndAnswers[item.key].[item.type] = item.value;
                this.$store.state.register.form.hitotonari.questionAndAnswers[item.key].[item.type] = this.hitotonari.questionAndAnswers[item.key].[item.type];
            },
            async deleteQAndAList(key) {
                const confirm = await this.$refs.confirmModal.show({ // 確認済み
                        title: '削除しますか？',
                        message: 'この質問・回答欄を削除しますか？',
                        mode: "delete",
                        name: "step10Confirm"
                });
                if (confirm) {
                    delete this.hitotonari.questionAndAnswers[key];
                    delete this.$store.state.register.form.hitotonari.questionAndAnswers[key];
                }
            },
            addQAndAList() {
                    var listNums = Object.keys(this.hitotonari.questionAndAnswers).map(Number);
                    if (listNums.length > 0) {
                        var nextKey = Math.max(...listNums) + 1;
                    } else {
                        var nextKey = 1;
                    }
                    this.hitotonari.questionAndAnswers[nextKey] = {question_check: 0, question_select_id: 0, question: '' , answer: ''};
            },
            displayHitotoanri(event) {
                var value = event.target.value;
                value = JSON.parse(event.target.value.toLowerCase());
                this.hitotonari.display = value;
                this.$store.state.register.form.hitotonari.diplay = this.hitotonari.display;
            },
            openAlertModal(mode, title, message) {
                this.alert_modal_mode = mode;
                this.alert_modal_title = title;
                this.alert_modal_message = message;
                this.showAlertModal = true;
            },
            closeAlertModal() {
                this.showAlertModal = false;
                this.alert_modal_mode = "";
                this.alert_modal_title = "";
                this.alert_modal_message = "";
            },
        },
        computed: {
            showBrand() {
                var url = location.pathname;
                return url.indexOf( '/brand' ) != -1;
            },
            showShowRoom() {
                var url = location.pathname;
                return url.indexOf( '/showroom' ) != -1;
            },
            showShop() {
                var url = location.pathname;
                return url.indexOf( '/shop' ) != -1;
            },
            showRegister() {
                var url = location.pathname;
                return url.indexOf( '/registration' ) != -1;
            },
            getName() {
                var url = location.pathname;
                if (url.indexOf( '/brand' ) != -1) {
                    return 'ブランド';
                } else if (url.indexOf( '/shop' ) != -1) {
                    return 'ショップ';
                } else if (url.indexOf( '/showroom' ) != -1) {
                    return 'ショールーム';
                }
            },
            pageTypeStep10() {
                var url = location.pathname;
                if (url.indexOf( '/registration' ) != -1) {
                    if (url.indexOf( '/shop' ) != -1) {
                        this.pageTypeBottom = '8rem';
                    }
                    //初回編集
                    return 0;
                } else if (url.indexOf( '/detail' ) != -1) {
                    //管理画面での編集
                    if (url.indexOf( '/shop' ) != -1) {
                        this.pageTypeBottom = '8rem';
                    }
                    return 1;
                } else {
                    //エンドユーザー側での表示
                    this.pageTypeTop = '8rem';
                    if (url.indexOf( '/shop' ) != -1) {
                        this.pageTypeBottom = '8rem';
                    }
                    return 2;
                }
            },
            getTextStep10() {
                var url = location.pathname;
                if (url.indexOf( '/registration' ) != -1) {
                    //初回編集
                    return '審査';
                } else if (url.indexOf( '/detail' ) != -1) {
                    //管理画面での編集
                    return '保存';
                }
            },
            personalAndBasic() {
                if (this.$store.state.detail.set.personalAndBasic) {
                    return true;
                }
            },
            unitAndBasic() {
                if (this.$store.state.detail.set.unitAndBasic) {
                    return true;
                }
            },
            activeBasicBrand() {
                if (this.$store.state.detail.set.activeBasicBrand) {
                    return true;
                }
            },
            adminAndBasic() {
                if (this.$store.state.detail.set.adminAndBasic) {
                    return true;
                }
            },
            personalAndShowRoom() {
                return this.$store.state.detail.set.personalAndShowRoom;
            },
            unitAndShowRoom() {
                return this.$store.state.detail.set.unitAndShowRoom;
            },
            basicAndShowRoom() {
                return this.$store.state.detail.set.basicAndShowRoom;
            },
            showRoomAndBasic() {
                return this.$store.state.detail.set.showRoomAndBasic;
            },
        }
    }
</script>